import store from '@user-center/store'
import {
  addition,
  subtraction,
  multiplication,
  division,
} from "@user-center/utils/common";
import {get,isArray,isObject,isString} from 'lodash-es'
export function checkIsQianKunSite() {
  return false;
}


export function isMallApp() {
  return false;
}

export function isMallAppApi() {
   
  return !! get(store, 'state.app.storeInfoData.offiaccountFollowData.otherJson.mallApiUrl');
}

function getBrowserStorage(): Storage | null {
  if (typeof window !== "undefined" && window.localStorage) {
    return window.localStorage;
  }
  if (typeof localStorage !== "undefined") {
    return localStorage;
  }
  return null;
}


export const mallAppKey="mall_app_user_key"
export const mallAppCurrentUserDataKey="mall_app_user_info"

export function setMallAppToken(val){
  getBrowserStorage()?.setItem(mallAppKey,val)
}

export function setCurrentUserInfo(val){
  getBrowserStorage()?.setItem(mallAppCurrentUserDataKey,val)
}


export function getCurrentUserInfo(){
 return getBrowserStorage()?.getItem(mallAppCurrentUserDataKey) || null
}
export function getMallAppToken(){
 return getBrowserStorage()?.getItem(mallAppKey) || null
}


export function checkMallFetchUrl(url:string):boolean {
  return url.indexOf('mall=1')>=0;
}


export function getMallUserInfoData():boolean {
  return get(store,'getters.userInfo.mallUserInfo',{})
}


export function findDeepValText(currentItem = {}, findKeys = [], transferList = []):void{
  // 递归查找翻译的中文
  findKeys.map((keys) => {
    keys.map((key, keyIx) => {
      let selectItem = get(currentItem, key);
      if (isArray(selectItem)) {
        selectItem.map((o) => {
          if(isObject(o)){
            findDeepValText(o, [keys.slice(keyIx + 1)], transferList);
          }else{
            transferList.push(o);
          }
        });
      } else if (isObject(selectItem)) {
        findDeepValText(selectItem, [keys.slice(keyIx + 1)], transferList);
      } else if (isString(selectItem)) {
        transferList.push(selectItem);
      }
    });
  });
}



export function getCurrencySymbol(defaultSymbol) {
  const currentCurrencyStr = getBrowserStorage()?.getItem("currentCurrency");
  let currentCurrency = null;
  try {
    currentCurrency = JSON.parse(currentCurrencyStr);
  } catch (e) {
    console.log(e);
  }
  if (currentCurrency && currentCurrency.toCurrencyCode == "CNY") {
    return defaultSymbol;
  }
  return currentCurrency &&
    (currentCurrency.shortCode ||
      currentCurrency.symbol ||
      currentCurrency.toCurrencyCode)
    ? currentCurrency.symbol ||
        currentCurrency.shortCode ||
        currentCurrency.toCurrencyCode
    : defaultSymbol;
}

export function getCurrencyNum(num) {
  const currentCurrencyStr = getBrowserStorage()?.getItem("currentCurrency");
  let currentCurrency = null;
  try {
    currentCurrency = JSON.parse(currentCurrencyStr);
  } catch (e) {
    console.log(e);
  }

  if (currentCurrency && currentCurrency.toCurrencyCode == "CNY") {
    return num;
  }
  if (typeof num == "string") {
    num = Number(num);
  }
  return currentCurrency && currentCurrency.exchangeRate && !isNaN(num)
    ? multiplication(currentCurrency.exchangeRate, num)
    : num;
}

if (typeof window !== "undefined") {
  window["_____getMallUserInfoData"] = getMallUserInfoData;
}
